module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    class: {
      'is-warning': _vm.isHom
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [(_vm.isHom) ? _c('p', {
    staticClass: "hom-warning"
  }, [_vm._v("SERVIDOR DE HOMOLOGAÇÃO")]) : _vm._e(), _c('p', [_c('a', {
    attrs: {
      "href": "//www.THEPES.com.br",
      "target": "_BLANK"
    }
  }, [_vm._v("THEPES")]), _vm._v(". Sistema Empresarial ERP, " + _vm._s(_vm.year) + ".")]), _c('p', [_c('small', [_vm._v("Versão "), _c('strong', [_vm._v(_vm._s(_vm.version))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b80bb336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 409
// module chunks = 56